<template>
  <div class="layout-header">
    <div class="layout-header__container">
      <router-link
        class="layout-header__logo"
        :to="homeRoute"
      >
        <img
          class="layout-header__logo__item"
          :src="logoUrl"
          :alt="title"
        />
      </router-link>

      <router-link
        :to="homeRoute"
        class="layout-header__title"
      >
        <h1 class="layout-header__title__item">
          <strong v-text="title" />
        </h1>
      </router-link>

      <div class="layout-header__buttons">
        <template v-if="!currentUser">
          <el-button
            class="layout-header__buttons__sign-up"
            type="secondary"
            @click="doSignUp"
          >
            <app-i18n code="auth.signup" />
          </el-button>

          <el-button
            class="layout-header__buttons__login"
            type="primary"
            @click="doLogin"
          >
            <app-i18n code="auth.login" />
          </el-button>
        </template>

        <template v-else>
          <p
            class="layout-header__username"
            v-text="currentUser.fullName"
          />
          <el-button
            class="layout-header__buttons__logout"
            type="primary"
            @click="doLogout"
          >
            <app-i18n code="auth.signout" />
          </el-button>
        </template>
      </div>

      <i18n-select class="layout-header__i18n" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import { logout } from '@/auth'

import i18nSelect from '@shared/i18n-utils/i18n-select.vue'

export default {
  name: 'layout-header',
  props: {
    title: String,
    logoUrl: String,
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
    }),
    slug() {
      return this.$route.params.slug
    },
    homeRoute() {
      return {
        name: 'home',
        params: {
          slug: this.slug,
        }
      };
    },
  },
  methods: {
    ...mapMutations({
      setLoginModalVisible: 'setLoginModalVisible',
      setSignupModalVisible: 'setSignupModalVisible',
    }),
    doSignUp() {
      this.setSignupModalVisible(true)
    },
    doLogin() {
      this.setLoginModalVisible(true)
    },
    async doLogout() {
      await logout()
    },
  },
  components: {
    i18nSelect
  }
}
</script>

<style lang="scss" scoped>
.layout-header {
  @include small-mobile {
    padding: 16px 12px;    
  }
  position: relative;
  z-index: 1;

  box-shadow: 0 2px 10px 0 rgba(51, 51, 51, 0.1);
  background-color: #ffffff;
  text-align: left;
  padding: 16px 32px;

  &__username {
    font-size: 14px;
    font-weight: 500;
    cursor: default;
  }

  .el-button {
    @include mobile {
      padding: 10px;
      font-size: 11px;
    }
  }

  &__container {
    @include layout-header;

    display: grid;
    grid-template-areas: 'logo title buttons i18n';
    grid-template-columns: auto 1fr auto auto;
    grid-template-rows: 50px;
    grid-column-gap: 16px;
    align-items: center;

    // @include small-mobile {
    //   grid-template-areas:
    //     'logo title i18n'
    //     'buttons buttons buttons';
    //   grid-template-columns: 1fr 3fr 1fr;
    //   grid-row-gap: 16px;  
    // }

    @include mobile {
      grid-template-areas: 
        'logo title i18n'
        'buttons buttons buttons';
      grid-template-columns: 2fr 5fr 1fr;
      //grid-template-columns: 40px auto auto;
      grid-row-gap: 16px;
    }
  }

  &__logo {
    grid-area: logo;

    &__item {
      height: 50px;
      object-fit: cover;
      width: 50px;
      border-radius: 50%;
      box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
    }
  }

  &__title {
    grid-area: title;

    @include mobile {
      width: 100%;
      text-align: center;
      justify-self: center;
    }

    &__item {
      margin: 0;
      font-size: 14px;
      font-weight: normal;
      letter-spacing: -0.2px;
      color: #404040;
      text-transform: uppercase;

      @include mobile {
        font-size: 18px;
      }

      strong {
        font-weight: bold;
        margin-right: 5px;
      }
    }
  }

  &__buttons {
    @include mobile {
      justify-content: center; 
    }
    grid-area: buttons;
    display: grid;
    grid-template-columns: repeat(auto-fill, 1fr);
    grid-auto-flow: column;
    grid-gap: 16px;
    align-items: center;
    justify-items: center;
    min-width: 150px;

    &__sign-up {
      width: 100%;
    }
  
    &__logout {
      width: 100%;

      @include mobile {
        min-width: 50%;
      }
    }
  
    &__login {
      width: 100%;

      .el-button + & {
        margin: 0;
      }
    }
  }

  &__i18n {
    grid-area: i18n;
    height: 32px;
  }
}
</style>
